import React from 'react';
import PropTypes from 'prop-types';
import CallReport from '@medflex/components/stories/CallReport';
import useCallReports from '../hooks/useCallReports';

const CallReportModule = ({ id }) => {
  const { reports } = useCallReports();

  const report = reports.find(_report => _report.id === id);

  return (
    <div className="flex flex-col p-4 min-h-0">
      <CallReport report={report} />
    </div>
  );
};

CallReportModule.propTypes = {
  id: PropTypes.string,
};

export default CallReportModule;
